/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {months} from '../../../constants/Common';
import {financialYear} from '../../../interface/Units';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import {formatIndian} from '../../../utils/formatIndian';
import {eachWordCap} from '../../../utils/FormUtils/FirstCap';

const TimeFrameDataTooltip: React.FC<{mainData: any}> = ({mainData}) => {
  const gap = 5;
  const companyDetails = useCompanyStore.getState().companyDetails;
  const fiscalYear: financialYear = companyDetails.fiscalYear;

  return (
    <Flex style={{width: '100% !important', justifyContent: 'space-around'}}>
      {mainData?.data?.length === 0 ? (
        <div
          style={{
            font: 'normal normal 600 14px/22px Montserrat',
            margin: '5px auto'
          }}
        >
          No Data
        </div>
      ) : mainData?.timeFrame === 'monthly' ? (
        <>
          {mainData?.data?.map((item: any, i: number) => {
            return (
              <Flex
                key={i}
                vertical={true}
                gap={gap}
                style={{margin: '5px'}}
                align="center"
                justify="center"
              >
                <div
                  style={{
                    font: 'normal normal 600 14px/22px Montserrat'
                  }}
                >
                  {months[fiscalYear][i]}
                </div>
                <div>{item.value ? formatIndian(item.value) : '-'}</div>
              </Flex>
            );
          })}
        </>
      ) : (
        <>
          {mainData?.data?.map((item: any, i: number) => {
            return (
              <Flex
                key={i}
                vertical={true}
                gap={gap}
                style={{margin: '5px auto'}}
                align="center"
                justify="center"
              >
                <div
                  style={{
                    font: 'normal normal 600 14px/22px Montserrat'
                  }}
                >
                  {eachWordCap(mainData?.timeFrame)}
                </div>
                <div>{item?.value ? formatIndian(item?.value) : '-'}</div>
              </Flex>
            );
          })}
        </>
      )}
    </Flex>
  );
};

export default TimeFrameDataTooltip;
